<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dO6WuH/tc-custom/9781613126011.jpg?1703734294223" alt="This image is the cover for the book Citizen Farmers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Citizen Farmers
      </h1>
      <p class="bookDescription body article font2">
        <b>A guide to organic vegetable gardens and small-scale farming with an emphasis on sustainability.</b><br/>  <br/> Biodynamic farming, with its focus on ecological sustainability, has emerged as the gold standard in the organic gardening movement. Daron Joffe—known as Farmer D—has made it his mission to empower, educate, and inspire people to become conscientious consumers, citizens, and stewards of the land.<br/>  <br/> In this engaging call to action, Farmer D teaches us to not only create sustainable gardens but also to develop a more holistic, community-minded approach to how our food is grown and how we live our lives in balance with nature. Illustrated with photographs of gardens designed by Farmer D as well as line drawings, the book is packed with advice on:<br/>   Establishing a biodynamic gardenCompostingSoil composition and replenishmentControlling pests and diseaseCooperative gardening practicesCreating delicious meals with your home-grown produce  <br/> In collaboration with a James Beard Award–nominated food journalist, Farmer D offers an indispensable resource for anyone who wants to make the world a greener place.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daron Joffe, Susan Puckett, Rinne Allen
      </h2>
      
      <p class="authorDescription body article">Daron Joffe is the founder of Farmer D Organics and designs and builds biodynamic farms all over the country for celebrity clients as well as nonprofit organizations. He and his company have appeared in the New York Times, the Los Angeles Times, and Southern Living, and on CNN’s Eatocracy. His Farmer D brand of compost is sold in Whole Foods stores in the Southeast, and his planting beds are sold through Williams-Sonoma. He lives in Oakland, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b1bfa68